import styles from './TrendingVerification.module.css';

const FIRE = ['🔥🔥🔥', '🔥🔥', '🔥', '🔥', '🔥'];

/** Normalise kind to exactly 'movie' or 'tv', defaulting to 'movie'. */
function normaliseKind(kind) {
    if (kind === 'tv') return 'tv';
    return 'movie';
}

export default function TrendingVerification({ trending = [], loading, onVerify }) {
    if (loading) {
        return (
            <aside className={styles.panel}>
                <h3 className={styles.title}>🔥 Trending to Verify</h3>
                {[1, 2, 3].map(i => <div key={i} className={styles.skeleton} />)}
            </aside>
        );
    }

    // Only show items that have a title and a usable tmdbId
    const validItems = trending.filter(item => item.title && item.tmdbId);

    if (!validItems.length) return null;

    return (
        <aside className={styles.panel}>
            <h3 className={styles.title}>🔥 Trending to Verify</h3>
            <div className={styles.list}>
                {validItems.slice(0, 5).map((item, i) => (
                    <button
                        key={item.tmdbId ?? i}
                        className={styles.row}
                        onClick={() => onVerify?.({
                            tmdbId: item.tmdbId,
                            kind:   normaliseKind(item.kind),
                        })}
                    >
                        <span className={styles.rank}>#{i + 1}</span>
                        <span className={styles.fire}>{FIRE[i] ?? '🔥'}</span>
                        {item.posterUrl && (
                            <img src={item.posterUrl} alt="" className={styles.poster} />
                        )}
                        <div className={styles.info}>
                            <span className={styles.itemTitle}>{item.title}</span>
                            <span className={styles.itemStats}>
                                {item.coinsEarnedToday ?? 0} coins today &middot;{' '}
                                <span className={styles.goldRate}>{item.goldRate ?? 0}% Gold</span>
                            </span>
                        </div>
                        <span className={styles.chevron}>›</span>
                    </button>
                ))}
            </div>
        </aside>
    );
}